module.exports = __webpack_public_path__ + "static/img/bankbook.297b2a38.png";